export class Fornecedor {
    id:  number | null = null;
    ativo?: boolean | null = true;
    nome: string = "";
    celular: string = "";
    dataCadastro: string = "";
    dataUltimaModificacao: string | null = null;
  }
